import $ from 'jquery';
import { getState } from '~src/state';

export const highlightCurrentPage = () => {
  const currentPageIndex = getState('currentPageIndex');
  $('.editor-sidebar-page-current').removeClass('editor-sidebar-page-current');
  $(`[data-page-index="${currentPageIndex}"]`).addClass(
    'editor-sidebar-page-current'
  );
};
